
import Loadable from 'react-loadable';
import Spinner from '../../components/spinner';


export default Loadable({
  loader: () => import(/* webpackChunkName: "ItemEdit"*/'./item-edit'),
  loading: Spinner
});
